import { Ability, AbilityBuilder, AbilityClass } from "@casl/ability";

// All protected subjects in the app
export type AppSubjects =
  | "Dashboard"
  | "PartyMaster"
  | "CityMaster"
  | "EmployeeMaster"
  | "TransporterMaster"
  | "PickList"
  | "CheckerPanel"
  | "PendingInvoice"
  | "PreDispatchReport"
  | "DispatchReport"
  | "DispatchSummary"
  | "Profile"
  | "all";

export type AppActions = "read" | "manage";

export type AppAbility = Ability<[AppActions, AppSubjects]>;
const AppAbilityClass = Ability as AbilityClass<AppAbility>;

export type UserRole = "super_admin" | "warehouse";

export function defineAbilityFor(role: UserRole | string | undefined): AppAbility {
  const { can, build } = new AbilityBuilder<AppAbility>(AppAbilityClass);

  if (role === "super_admin") {
    can("manage", "all");
  } else if (role === "warehouse") {
    can("read", "CheckerPanel");
    can("read", "Profile");
  } else {
    // Unknown role: no access
  }

  return build();
}

// Default redirect path per role
export function getDefaultPathForRole(role: UserRole | string | undefined): string {
  if (role === "warehouse") return "/checker-panel";
  return "/";
}
